<template>
    <div class="mt-4 grid grid-cols-1 md:grid-cols-2 gap-2 p-4 bg-white rounded">
        <div>
            <h5 class="text-lg font-semibold text-gray-700">Update Password</h5>
            <p class="text-gray-600">
                Ensure your account is using a long, random password to stay
                secure.
            </p>
        </div>
        <div class="my-3 shadow rounded grid grid-cols-4 gap-4 p-5">
            <div class="col-span-4">
                <label
                    for="current_password"
                    class="block text-sm font-medium text-gray-700"
                    >Current Password</label
                >
                <input
                    v-model="form.current_password"
                    type="password"
                    name="current_password"
                    id="current_password"
                    class="
                        mt-1
                        focus:ring-indigo-500 focus:border-indigo-500
                        block
                        w-full
                        shadow-sm
                        sm:text-sm
                        border-gray-300
                        rounded-md
                    "
                />
                <p v-if="form.hasErrors" class="text-sm text-red-600">
                    {{ form.errors.updatePassword.current_password }}
                </p>
            </div>
            <div class="col-span-4">
                <label
                    for="password"
                    class="block text-sm font-medium text-gray-700"
                    >New Password</label
                >
                <input
                    v-model="form.password"
                    type="password"
                    name="password"
                    id="password"
                    class="
                        mt-1
                        focus:ring-indigo-500 focus:border-indigo-500
                        block
                        w-full
                        shadow-sm
                        sm:text-sm
                        border-gray-300
                        rounded-md
                    "
                />
                <p v-if="form.hasErrors" class="text-sm text-red-600">
                    {{ form.errors.updatePassword.password }}
                </p>
            </div>
            <div class="col-span-4">
                <label
                    for="password_confirmation"
                    class="block text-sm font-medium text-gray-700"
                    >Confirm Password</label
                >
                <input
                    v-model="form.password_confirmation"
                    type="password"
                    name="password_confirmation"
                    id="password_confirmation"
                    class="
                        mt-1
                        focus:ring-indigo-500 focus:border-indigo-500
                        block
                        w-full
                        shadow-sm
                        sm:text-sm
                        border-gray-300
                        rounded-md
                    "
                />
                <p v-if="form.hasErrors" class="text-sm text-red-600">
                    {{ form.errors.updatePassword.password_confirmation }}
                </p>
            </div>
            <div class="col-span-4 flex justify-end">
                <button
                    @click="updatePassword"
                    class="
                        inline-flex
                        items-center
                        px-4
                        py-2
                        bg-gray-800
                        border border-transparent
                        rounded-md
                        font-semibold
                        text-xs text-white
                        uppercase
                        tracking-widest
                        hover:bg-gray-700
                        active:bg-gray-900
                        focus:outline-none
                        focus:border-gray-900
                        focus:shadow-outline-gray
                        transition
                        ease-in-out
                        duration-150
                    "
                >
                    Save
                </button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            form: this.$inertia.form(
                {
                    current_password: "",
                    password: "",
                    password_confirmation: "",
                },
                {
                    bag: "updatePassword",
                    resetOnSuccess: false,
                }
            ),
        };
    },
    methods: {
        updatePassword() {
            this.form.post(route("admin.user.password.update"), {
                preserveScroll: true,
                onSeccess: () => {
                    this.form.reset(), this.form.clearErrors();
                },
            });
        },
    },
};
</script>
